import PropTypes from 'prop-types';
import React from 'react';

import AddProduct from './add-product';

const Toast = ({ title, variant = 'default', ...props }) => {
	const variants = {
		add_product: {
			Component: AddProduct,
		},
		default: {},
	};

	const ToastComponent = variants[variant]?.Component || null;

	return (
		<>
			{ToastComponent && <ToastComponent title={title} {...props} />}
			{!ToastComponent && <>{title}</>}
		</>
	);
};

Toast.propTypes = {
	title: PropTypes.string,
	variant: PropTypes.string,
};

export default Toast;
